function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: url(#Sfumatura_senza_nome_18-2);      }      .cls-2 {        fill: url(#Sfumatura_senza_nome_18-3);      }      .cls-3 {        fill: url(#Sfumatura_senza_nome_18);      }      .cls-4 {        fill: url(#Sfumatura_senza_nome_18-4);      }      .cls-5 {        opacity: .1;      }    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_18",
  "data-name": "Sfumatura senza nome 18",
  x1: -10.667,
  y1: -19.647,
  x2: 77.842,
  y2: 61.066,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0c73e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19c1ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_18-2",
  "data-name": "Sfumatura senza nome 18",
  x1: -25.772,
  y1: -3.083,
  x2: 62.737,
  y2: 77.63,
  xlinkHref: "#Sfumatura_senza_nome_18"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_18-3",
  "data-name": "Sfumatura senza nome 18",
  x1: -10.667,
  y1: -19.648,
  x2: 77.843,
  y2: 61.065,
  xlinkHref: "#Sfumatura_senza_nome_18"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_18-4",
  "data-name": "Sfumatura senza nome 18",
  x1: -25.772,
  y1: -3.083,
  x2: 62.737,
  y2: 77.63,
  xlinkHref: "#Sfumatura_senza_nome_18"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_3",
  "data-name": "Livello 3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
});

function SvgUtilities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,35.903c-3.692,0-7.161-1.438-9.77-4.048-5.089-5.088-5.476-13.066-.902-18.557,7.025-8.437,14.313-8.438,21.346,0h0c4.573,5.492,4.185,13.469-.903,18.558-2.609,2.61-6.079,4.048-9.77,4.048Zm0-25.049c-2.929,0-5.786,2.691-7.666,4.949-3.216,3.862-2.926,9.698,.662,13.286,3.743,3.741,10.265,3.741,14.007,0,3.588-3.588,3.879-9.424,.664-13.286-1.881-2.258-4.739-4.949-7.667-4.949Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.351,63.03H17.649c-5.897,0-10.694-4.797-10.694-10.694s4.797-10.694,10.694-10.694H52.351c5.897,0,10.694,4.797,10.694,10.694s-4.797,10.694-10.694,10.694ZM17.649,45.556c-3.739,0-6.781,3.042-6.781,6.781s3.042,6.781,6.781,6.781H52.351c3.739,0,6.781-3.042,6.781-6.781s-3.042-6.781-6.781-6.781H17.649Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_18-2)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.17,14.551c-2.534-3.042-5.715-5.653-9.17-5.653s-6.635,2.611-9.17,5.653c-3.906,4.689-3.533,11.606,.783,15.922h0c4.632,4.632,12.142,4.632,16.774,0h0c4.316-4.316,4.689-11.232,.783-15.922Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_18-3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.912,
    y: 43.599,
    width: 52.176,
    height: 17.474,
    rx: 3.349,
    ry: 3.349,
    style: {
      fill: "url(#Sfumatura_senza_nome_18-4)"
    }
  }))))), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities);
export default __webpack_public_path__ + "static/media/utilities.9566d986.svg";
export { ForwardRef as ReactComponent };